import React, { useState } from "react";
import { ImageLightbox } from "../ui/ImageLightbox";

interface ManufacturingSectionProps {
  heading: string;
  summary: string;
  fullText: string;
  image: string;
}

export function ManufacturingSection({
  heading,
  summary,
  fullText,
  image,
}: ManufacturingSectionProps) {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <section className="bg-black py-20 px-4">
      <div className="w-full lg:w-[92%] mx-auto px-4">
        <div className="flex flex-col items-center text-center gap-8">
          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#fbbf24]">
            {heading}
          </h2>

          {/* Image */}
          <div className="w-full flex justify-center">
            <div
              className="relative max-w-2xl max-h-[75vh] rounded-xl overflow-hidden bg-black cursor-pointer transition-transform hover:scale-105"
              onClick={() => setIsLightboxOpen(true)}
            >
              <img
                src={image}
                alt={heading}
                className="w-full h-auto max-h-[75vh] object-contain"
                loading="lazy"
              />
            </div>
          </div>

          {/* Expandable Text */}
          <div className="text-lg text-gray-300 leading-relaxed max-w-3xl">
            <p className="whitespace-pre-line">
              {isExpanded
                ? fullText
                : `${summary.substring(0, summary.indexOf("Our canopies") + 14)}...`}
              {isExpanded ? "  " : " "}
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="text-[#fbbf24] hover:text-[#fb923c] font-semibold underline transition-colors"
                style={{ fontSize: "0.67em" }}
              >
                {isExpanded ? "Show Less" : "Read More"}
              </button>
            </p>
          </div>
        </div>
      </div>

      {/* Image Lightbox */}
      <ImageLightbox
        imageUrl={image}
        imageAlt={heading}
        isOpen={isLightboxOpen}
        onClose={() => setIsLightboxOpen(false)}
      />
    </section>
  );
}
